import React from "react";
import { ViewDetailsHeading } from "../../../../components/ViewDetailsHeading";
import { NameAndHub } from "../NameAndHub";
import { Row, Col } from "antd";

export function ViewFirmDetails({ firmDetails, apiResponse, id }) {
  return (
    <>
      {" "}
      <ViewDetailsHeading
        text={"Firm Details"}
        itemkey={1}
        apiResponse={apiResponse}
        id={id}
      />
      <div className="view-basic-details">
        <div className="view-details-header">
          <div className="view-details-header-text">Firm Details</div>
        </div>
        {/* <div className="view-basic-details-contain">
        
        </div> */}
        <Row className="basic-details-view">
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Name of proprietor / partner "}
                  hub={firmDetails?.proprietorName}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Name of firm"}
                  hub={firmDetails?.nameAsPerGST}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"PAN number"} hub={firmDetails?.pan} />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Is GST Registered"}
                  hub={firmDetails?.gstRegistred}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"MIME"}
                  hub={firmDetails?.msme == true ? "Yes" : "No"}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"GSTIN number"} hub={firmDetails?.gst} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"Firm type"} hub={firmDetails?.firmType} />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
